import Image from 'app/Components/Shared/Image/image';
import React, { useEffect,useState } from 'react';
import { connect } from 'react-redux';
import ProviderManager from '../../../provider/providerManager';
import { buildUrlAndOpenSameWindow } from '../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../Config';
import BtnSubmit from '../Buttons/BtnSubmit';
import TextInput from '../TextInput/TextInput';
import callServiceIcon from './images/call-service-icon.svg';
import alertIcon from './images/alert-icon.svg';
import successIcon from './images/success-icon.svg';

const CallBack = (props) => {
const [errorDescription, setErrorDescription] = useState('');
const [contactNumber, setContactNumber] = useState('');
const [displayCreateOrderError , setDisplayCreateOrderError] = useState(false);
const subtitle = props.subTitle ?? 'נציג יחזור אליך בהקדם להמשך טיפול';
const [content , setContent] = useState({type: '' , icon: '' , title: '' , subTitle: subtitle , btnText: ''});

    useEffect  (() => {
        setDisplayCreateOrderError(false);
        setContent({type: 'callback' , icon: callServiceIcon , title: 'לאיזה מספר לחזור?' , subTitle: subtitle , btnText: 'תחזרו אליי'})
        if (props.contactNumber?.length === 10) {
            const contactNumberFormat = props.contactNumber.slice(0, 3) + '-' + props.contactNumber.slice(3);
            setContactNumber(contactNumberFormat);
        }
    },[]);

    const handleOnContinue = async ()=>{
        if(content.type == 'callback'){
            const phonePattern = /^0((5\d{1})|([2-4,8-9]\d{0,1}))-?\d{7}$/;

            if (!phonePattern.test(contactNumber) || contactNumber.length < 9) {
                setErrorDescription('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
            } else {
                doCallBack();
            }
        }else{
            buildUrlAndOpenSameWindow(Config.lobbyUrl);
        }

    };

    async function doCallBack(){
        try{
            const cleanedPhoneNumber = contactNumber.replace(/-/g, '');
            const response = await ProviderManager.getProviderData('createIvrCallback', [cleanedPhoneNumber, props.subjectCode]);
            if(response.Body?.isSuccess){
                setDisplayCreateOrderError(false);
                setContent({type: 'success' , icon: successIcon , title: 'קיבלנו, אנחנו על זה' , subTitle: subtitle, btnText: 'סיום'});
                if(props.dwhParams) reportDWH('Completed' , 'CallBack Added to Queue');
                createMemo();
            }else{
                if(props.dwhParams) reportDWH('Error' , 'General Error');
                setDisplayCreateOrderError(true);
            }
        }catch(error){
            if(error.errorCode == 3){
                setDisplayCreateOrderError(false);
                setContent({type: 'alreadyHaveCallBack' , icon: alertIcon , title: 'ראינו שכבר מתואמת שיחה חזרה אליך', subTitle: subtitle, btnText: 'סיום'})
            }else{
                if(props.dwhParams) reportDWH('Error' , 'General Error');
                setDisplayCreateOrderError(true);
            }
        }
    }

    function createMemo(){
        const isAuthenticated = props.loginData?.isFullAuthenticated || props.loginData?.isOtpAuthenticated || props.loginData?.isOtpExtendedAuthenticated || props.loginData?.isSilentOtpAuthenticated;
        if(isAuthenticated && (props.memoCode && props.memoText)){
            const params = {
                memoType: props.memoCode,
                memoManualTxt: props.memoText,
            };
            ProviderManager.getProviderData('createMemo', params);
        }
    }

   function reportDWH(status, messageText) {
          let loginType = '';
          if (props.loginData?.isOtpAuthenticated) {
              loginType = 'OTP';
          }
          if (props.loginData?.isOtpExtendedAuthenticated) {
              loginType = 'OTP מורחב';
          }
          if (props.loginData?.isFullAuthenticated) {
              loginType = 'לקוח';
          };
          const reportParams = {
            //required
            area: props.dwhParams.area,
            subArea: props.dwhParams.subArea,
            channel: props.dwhParams.channel,
            actionType: 'CallBack',
            status: status, //Ongoing | Completed | Error
            messageText: messageText,

            //optional
            customerName: `${props.loginData?.userDetails?.firstName ?? ''} ${props.loginData?.userDetails?.lastName ?? ''}`,
            email: '',
            banId: '',
            psId: '',
            idNumber: props.loginData?.userDetails.IDNumber ?? '',
            subscriber: props.loginData?.userDetails.contactNumber ?? '',
            cmrId: '',
            param1: '',
            param2: '',
            param3: '',
            param4: '',
            param5: '',
            param6: '',
            param7: '',
            param8: '',
            param9: props.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי',
            param10: loginType,
          };
        const reportItem = {
            eReportingType: 3,
            reportItem: reportParams,
        };

        ProviderManager.getProviderData('report', reportItem);
    }

    function changePhoneInputHandler(value){
        setErrorDescription('');
        setContactNumber(value);
    }

  return (
      <div className='call-back'>
        <div className='content-wrapper'>
            <Image src={content.icon} alt='call back icon' />
            <h1>{content.title}</h1>
            <h2>{content.subTitle}</h2>
            {content.type == 'callback' && <TextInput
                className='contact-number-input'
                name='contactNumber'
                type='text'
                pattern='[0-9]*'
                id='contactNumber'
                maxLength='10'
                autoComplete='off'
                placeholder={'מספר טלפון'}
                required='required'
                value={contactNumber}
                error={errorDescription}
                onChange={(e) => changePhoneInputHandler(e.target.value)}
                ></TextInput>}
        </div>
        <div className='button-wrapper'>
            {displayCreateOrderError && <span className='work-order-error'>השליחה נכשלה, אנא נסו שוב</span>}
            <BtnSubmit
                className={content.type == 'callback' ? '' : 'background-white' }
                isBusiness={false}
                text={content.btnText}
                onclick={()=>handleOnContinue()}
                formid='call-back-page'
            />
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {

  return {
    loginData : state.authentication.loginData
  };
};

const mapDispatchToProps = { };

export default connect(mapStateToProps, mapDispatchToProps)(CallBack);
